export function filterArrNil<T>(value: T): value is NonNullable<T> {
  return value != null;
}
